import React, { useState } from "react";
import { Lock, Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

/**
 * Campo de senha com botão "olho" para mostrar/ocultar.
 * Reutilizável em Login, Cadastro, RedefinirSenha, etc.
 *
 * Acessibilidade:
 * - aria-label dinâmico no toggle ("Mostrar senha"/"Ocultar senha")
 * - tabIndex=0 no botão para suporte a teclado
 * - aria-pressed reflete o estado atual
 */
export default function PasswordInput({
  value,
  onChange,
  testId = "password-input",
  toggleTestId,
  autoComplete = "current-password",
  placeholder = "••••••••",
  required = true,
  minLength,
  ...rest
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-navy/40 pointer-events-none" />
      <Input
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="pl-10 pr-11 h-11 bg-white"
        data-testid={testId}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
        aria-pressed={visible}
        tabIndex={0}
        data-testid={toggleTestId || `${testId}-toggle`}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-md text-navy/55 hover:text-navy hover:bg-navy/5 focus:outline-none focus:ring-2 focus:ring-gold/40 transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
